import { defineReport } from '@tnn/core'
import { waybill } from './waybill'

/**
 * บิลงานขนส่ง: the bills booked in a period — how many, their pieces, weight and freight, and what was taken of it —
 * by day or month, by the branch that sent or receives them, the province, the sender, who pays, or where they are
 */
export const waybillReport = defineReport({
  app: 'tms',
  name: 'waybills',
  resource: waybill,
  date: 'bookedAt',
  groups: [
    'bookedAt:day',
    'bookedAt:month',
    'originBranchId',
    'destBranchId',
    'receiverProvince',
    'senderId',
    'payer',
    'paymentStatus',
    'status',
  ],
  sums: ['pieces', 'weightKg', 'fee', 'senderPaid', 'receiverPaid'],
  // Drafts are not bookings yet, and a cancelled bill was never one
  where: { docstatus: { op: 'in', values: ['submitted'] } },
})
